define('home/templates/channelCreateError',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression;

  return "<div class=\"modal-header\">\n<h4 class=\"modal-title\">"
    + alias1(helpers.gettext.call(depth0 != null ? depth0 : {},"Uh oh, we weren't able to create your channel",{"name":"gettext","hash":{},"data":data}))
    + "</h4>\n</div>\n<div class=\"modal-body\">\n<p>"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.responseJSON : depth0)) != null ? stack1.response : stack1), depth0))
    + "</p>\n</div>\n";
},"useData":true})

});
